import { native } from '@forest/native-services'
import { createEffect } from 'solid-js'
import { EVENT_END_MS } from '~/config'
import { useTimestamp } from './use-timestamp'

export function shouldCloseForClockGuard(input: {
  nowMs: number
  eventEndMs: number
}): boolean {
  return input.nowMs >= input.eventEndMs
}

export function useDeviceClockGuard() {
  const timestamp = useTimestamp()
  // Re-check on every timestamp refresh: initial seed, each 60s refetch,
  // and refetch-on-window-focus (which covers the device-backgrounded case).
  createEffect(() => {
    const nowMs = timestamp.data
    if (typeof nowMs !== 'number' || nowMs <= 0) return
    if (shouldCloseForClockGuard({ nowMs, eventEndMs: EVENT_END_MS })) {
      native.general.close()
    }
  })
}
